import {
    container,
    title,
    main,
    mainRaised,
    mrAuto,
    mlAuto,
    description
  } from "assets/jss/material-kit-pro-react.jsx";

  import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.jsx";
  import featuresStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.jsx";

  const additionalInfoStyle = {
    container,
    main,
    mainRaised,
    title,
    mrAuto,
    mlAuto,
    description,
    ...aboutUsStyle,
    ...featuresStyle,
    block: {
        color: "inherit",
        padding: "0.9375rem 0",
        fontWeight: "500",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        textDecoration: "none",
        position: "relative",
        display: "block"
      },
  }

  export default additionalInfoStyle;